import React from "react";
import {
  Calendar,
  Callout,
  DayOfWeek,
  DefaultButton,
  DirectionalHint,
  FocusTrapZone,
  IBasePickerSuggestionsProps,
  ITag,
  PrimaryButton,
  Stack,
  TagPicker,
  Text,
  TextField,
  NormalPeoplePicker,
  IPersonaProps,
} from "@fluentui/react";
import { Formik, FormikErrors } from "formik";
import { ICustomers, IPreventiveMaintenenceSchedule } from "../../vm";
import {
  childrenGap,
  DayPickerStrings,
  FILE_UPLOAD_CONFIG,
  FILE_UPLOAD_MODULES,
} from "../common/Constants";
import CustomDrawer from "../common/CustomDrawer";
import { ToastContext } from "../common/ToastProvider";
import * as yup from "yup";
import moment from "moment";
import {
  addPMScheduleFile,
  uploadPMSFile,
} from "../../services/pm-schedule/PMScheduleService";
import { mdiCloseCircle } from "@mdi/js";
import { THEME } from "../../utils/Styles";
import Icon from "@mdi/react";
import XLLogo from "../../images/xl.png";
import { getAllCustomersByDC } from "../../services/customers/CustomerService";
import { Loading } from "../../services/Loading";
import {
  getFileTypeErrorMessage,
  validateFileType,
} from "../../services/UtilService";

// const pmsSchema = yup.object().shape({
//   date: yup.date().required("required"),
//   file: yup.string().required("required"),
// });

let calendarButtonElement: HTMLElement;

export interface ManagePMScheduleDialogProps {
  handleLoading: any;
  handleDialogClose: any;
  date: Date | string;
  datacenterId?: string;
  customer?: ICustomers;
  datacenterList?: ITag[];
  pmsFiles?: IPreventiveMaintenenceSchedule[];
  data?: IPreventiveMaintenenceSchedule;
}

const ManagePMScheduleDialog: React.FC<ManagePMScheduleDialogProps> = ({
  handleDialogClose,
  handleLoading,
  datacenterId,
  customer,
  datacenterList,
  pmsFiles,
  data,
  date,
}) => {
  //custom hooks
  const { showToast } = React.useContext(ToastContext);

  // file upload config
  const fileUploadConfig =
    FILE_UPLOAD_CONFIG[FILE_UPLOAD_MODULES.MANAGE_PM_SCHEDULE];

  //state
  const [state, setState] = React.useState({
    pmsFile: {
      datacenterId: datacenterId ? datacenterId : "",
      date: new Date(date),
      file: undefined,
      customerId: customer?._id ? customer._id : "",
      customerIds: customer?._id ? [customer._id] : [],
      isNewFileUploaded: false,
      ...data,
    },
    showCallender: false,
    selectedFile: undefined,
    selectedDatacenter: [],
    selectedCustomers: [],
    // selectedCustomers: [
    //   {
    //     text: customer?.name,
    //     secondaryText: customer?.regSapNo,
    //     id: customer?._id,
    //   },
    // ],
  } as {
    pmsFile: IPreventiveMaintenenceSchedule;
    showCallender: boolean;
    selectedFile?: File;
    selectedDatacenter: ITag[];
    selectedCustomers: Array<{
      text: string;
      secondaryText: string;
      id: string;
    }>;
  });
  const [isLoading, setLoading] = React.useState(false as boolean);

  //hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      let selectedDatacenter: ITag[] = [];
      let selectedCustomers: Array<{
        text: string;
        secondaryText: string;
        id: string;
      }> = [];
      if (data && data.datacenterId !== "" && datacenterList) {
        datacenterList.forEach((ele) => {
          if (ele.key === data.datacenterId) {
            selectedDatacenter.push(ele);
          }
        });
      }
      if (data?._id) {
        // finding selecting customers
        const customers = await getSelectedCustomers(data.customerIds);
        customers.forEach((d: ICustomers) => {
          selectedCustomers.push({
            text: d.name,
            secondaryText: d.regSapNo,
            id: d._id as string,
          });
        });
      } else {
        // adding default customer
        selectedCustomers.push({
          text: customer?.name as string,
          secondaryText: customer?.regSapNo as string,
          id: customer?._id as string,
        });
      }
      setState({
        ...state,
        selectedDatacenter,
        selectedCustomers,
      });
    };
    asyncFunc();
  }, []);

  const getSelectedCustomers = async (customerIds: string[]) => {
    setLoading(true);
    const result = await getAllCustomersByDC({ customerIds });
    setLoading(false);
    if (result?.success) {
      return result.data;
    } else {
      showToast(result?.message || "Error while getting customers", "error");
    }
  };

  const closeAddDialog = (data?: IPreventiveMaintenenceSchedule) => {
    handleDialogClose(data);
  };

  const handleFileChange = (files: any) => {
    console.log(typeof files[0]);

    if (files && files.length > 0) {
      // Validate file type
      const isValidType = validateFileType(
        files[0],
        fileUploadConfig.acceptedFileTypes
      );

      if (!isValidType) {
        showToast(
          getFileTypeErrorMessage(fileUploadConfig.fileTypeDescription),
          "error"
        );
      }
      console.log("f", files[0]);
      setState({
        ...state,
        selectedFile: files[0],
      });
    } else {
      showToast("Select only valid file", "error");
    }
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  const uploadFile = async (fileName: string, file: File) => {
    handleLoading();
    let result = await uploadPMSFile(file);
    handleLoading();
    if (result.success) {
      return result?.data?.fileName || "";
      // return fileName;
    } else {
      showToast(result.message || `Error while uploading image`, "error");
    }
    return undefined;
  };

  const deleteImage = (values: any) => {
    setState({
      ...state,
      pmsFile: {
        ...values,
        file: undefined,
      },
      selectedFile: undefined,
    });
  };

  const datacenterPickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No datacenter found",
  };

  const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No Customer found",
  };

  const filterSuggestedTags = (filterText: string, tagList: ITag[]): ITag[] => {
    let allPmsFile = pmsFiles ? [...pmsFiles] : [];
    let allDataCenterList = datacenterList ? [...datacenterList] : [];

    allPmsFile.forEach((item) => {
      allDataCenterList = allDataCenterList.filter(
        (ele) => ele.key !== item.datacenterId
      );
    });

    return filterText
      ? allDataCenterList.filter(
          (tag) =>
            tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
            !listContainsTagList(tag, tagList)
        )
      : [];
  };

  const showAllTags = (selectedItems?: ITag[] | undefined) => {
    let allPmsFile = pmsFiles ? [...pmsFiles] : [];
    let allDataCenterList = datacenterList ? [...datacenterList] : [];

    allPmsFile.forEach((item) => {
      allDataCenterList = allDataCenterList.filter(
        (ele) => ele.key !== item.datacenterId
      );
    });

    console.log(allDataCenterList);
    return removeDuplicates(allDataCenterList, selectedItems);
  };

  function removeDuplicates(tagList: ITag[], tags?: ITag[]) {
    return tagList.filter((tag) => !listContainsTagList(tag, tags));
  }

  const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
    if (!tagList || !tagList.length || tagList.length === 0) {
      return false;
    }
    return tagList.some((compareTag) => compareTag.key === tag.key);
  };

  const onFilterChanged = async (
    filterText: string,
    tagList?: IPersonaProps[]
  ): Promise<IPersonaProps[]> => {
    if (filterText && filterText.length >= 2) {
      let result = await getAllCustomersByDC({
        datacenterIds: state.selectedDatacenter.map((d) => d.key as string),
        search: filterText,
      });
      if (result?.success) {
        const cardHolderTag: IPersonaProps[] = [];
        const selectedCustomerIds = tagList?.map((d) => d.id);

        result?.data.forEach((item: any) => {
          if (!selectedCustomerIds?.includes(item._id as string)) {
            cardHolderTag.push({
              text: item.name,
              secondaryText: item.regSapNo,
              id: item._id,
            });
          }
        });
        return cardHolderTag;
      } else {
        return [];
      }
    }
    return [];
  };

  return (
    <React.Fragment>
      {isLoading && <Loading />}
      <CustomDrawer
        title={
          data?._id
            ? "Update Preventive Maintenence Schedule File"
            : "Add Preventive Maintenence Schedule File"
        }
        handelOpen={true}
        onClose={() => closeAddDialog()}
      >
        <Stack>
          <Formik
            enableReinitialize
            initialValues={state.pmsFile}
            // validationSchema={pmsSchema}
            validate={(values) => {
              let errors: FormikErrors<IPreventiveMaintenenceSchedule> = {};
              if (!values.date) {
                errors.date = "Required";
              }
              if (!values.file && !state.selectedFile) {
                errors.file = "Required";
              } else if (state.selectedFile) {
                const isValidType = validateFileType(
                  state.selectedFile,
                  fileUploadConfig.acceptedFileTypes
                );

                if (!isValidType) {
                  errors.file = getFileTypeErrorMessage(
                    fileUploadConfig.fileTypeDescription
                  );
                }
              }
              if (customer && !values.datacenterId) {
                errors.datacenterId = "Required";
              }
              if (values.customerIds && values.customerIds.length < 1) {
                errors.customerIds = "Required";
              }
              if (
                values.customerIds &&
                values.customerIds.length > 0 &&
                !values.customerIds.includes(customer?._id as string)
              ) {
                errors.customerIds = `Select ${customer?.name} customer first`;
              }
              return errors;
            }}
            onSubmit={async (
              values: IPreventiveMaintenenceSchedule,
              { setSubmitting }
            ) => {
              let obj = { ...values };
              obj.date = moment(obj.date).format("YYYY-MM-DD");
              let result;
              if (state.selectedFile) {
                let name =
                  new Date().getTime() +
                  "-" +
                  state.selectedFile.name.toLowerCase().replace(/ /g, "");
                let fileName = await uploadFile(name, state.selectedFile);
                if (fileName) {
                  obj.file = fileName;
                  // newly added to confirm that a new file is uploaded or not
                  obj.isNewFileUploaded = true;
                } else return;
              }
              // belongs to old logic
              // if (obj.customerId === "") {
              //   delete obj.customerId;
              // }
              console.log("VALUES", obj);
              handleLoading();
              result = await addPMScheduleFile(obj);
              handleLoading();
              if (result?.success) {
                closeAddDialog(result.data);
              } else {
                showToast(
                  result?.message || `Error while uploading file`,
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={childrenGap}>
                  <Stack.Item>
                    <div className="ms-Grid p-0">
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md2 ms-lg3 ms-xl3 ms-xxl3">
                          <div
                            ref={(calendarBtn) =>
                              (calendarButtonElement = calendarBtn!)
                            }
                          >
                            <DefaultButton
                              text={
                                !values.date
                                  ? "Select a month"
                                  : moment(values.date).format("YYYY")
                              }
                              onClick={() =>
                                setState({ ...state, showCallender: true })
                              }
                              className="month-picker-btn"
                            />
                          </div>
                          {state.showCallender && (
                            <Callout
                              isBeakVisible={false}
                              gapSpace={0}
                              doNotLayer={false}
                              target={calendarButtonElement}
                              directionalHint={DirectionalHint.bottomLeftEdge}
                              onDismiss={() => closeCallender()}
                              setInitialFocus
                            >
                              <FocusTrapZone
                                firstFocusableSelector="ms-DatePicker-day--today"
                                isClickableOutsideFocusTrap
                              >
                                <Calendar
                                  // eslint-disable-next-line react/jsx-no-bind
                                  onSelectDate={(
                                    date: Date | null | undefined
                                  ) => {
                                    setFieldValue("date", date);
                                    setState({
                                      ...state,
                                      showCallender: false,
                                    });
                                  }}
                                  onDismiss={() => closeCallender()}
                                  isMonthPickerVisible={true}
                                  value={new Date(values.date)}
                                  firstDayOfWeek={DayOfWeek.Sunday}
                                  strings={DayPickerStrings}
                                  isDayPickerVisible={false}
                                  highlightCurrentMonth={false}
                                  highlightSelectedMonth={true}
                                  showMonthPickerAsOverlay={false}
                                  showGoToToday={false}
                                />
                              </FocusTrapZone>
                            </Callout>
                          )}
                        </div>
                        {!values.file && (
                          <div className="ms-Grid-col ms-sm12 ms-md10 ms-lg9 ms-xl9 ms-xxl9 custom-textfield">
                            <TextField
                              name="file"
                              type="file"
                              accept={fileUploadConfig.acceptedFileTypes}
                              onChange={(event: any) =>
                                handleFileChange(event.target.files)
                              }
                              onBlur={handleBlur}
                              label="Select a file"
                              errorMessage={
                                errors.file && touched.file
                                  ? (errors.file as string)
                                  : ""
                              }
                              description={fileUploadConfig.hintText}
                              className="file-selector"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </Stack.Item>
                  {values.file && (
                    <Stack.Item styles={{ root: { marginBottom: 50 } }}>
                      <div className="ms-Grid">
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4 ms-xxl4 c-height">
                            <img
                              className="w-100"
                              src={XLLogo}
                              alt="log"
                              style={{ marginLeft: -22 }}
                            />
                            <span
                              className="img-delete-icon"
                              onClick={() => deleteImage(values)}
                            >
                              <Icon
                                path={mdiCloseCircle}
                                size={0.8}
                                className="pointer"
                                color={THEME.palette.themePrimary}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </Stack.Item>
                  )}
                  {customer && (
                    <Stack.Item className="custom-picker">
                      <TagPicker
                        removeButtonAriaLabel="Remove"
                        itemLimit={1}
                        selectedItems={state.selectedDatacenter}
                        onResolveSuggestions={filterSuggestedTags as any}
                        pickerSuggestionsProps={
                          datacenterPickerSuggestionsProps
                        }
                        onEmptyResolveSuggestions={showAllTags}
                        // getTextFromItem={getTextFromItem}
                        inputProps={{
                          placeholder: "Select a particular datacenter",
                        }}
                        onChange={(items: any) => {
                          let datacenterId: string = "";
                          items.forEach((ele: any) => {
                            datacenterId = ele.key;
                          });
                          setFieldValue("datacenterId", datacenterId);
                          setState({
                            ...state,
                            selectedDatacenter: items,
                          });
                        }}
                        disabled={data && data.datacenterId !== ""}
                      />
                      {errors.datacenterId && touched.datacenterId && (
                        <Text className="error-msg">{errors.datacenterId}</Text>
                      )}
                    </Stack.Item>
                  )}
                  <Stack.Item className="custom-picker">
                    <NormalPeoplePicker
                      inputProps={{
                        placeholder: "Search customers",
                      }}
                      onResolveSuggestions={onFilterChanged}
                      selectedItems={state.selectedCustomers}
                      removeButtonAriaLabel="Remove"
                      pickerSuggestionsProps={pickerSuggestionsProps}
                      onChange={(items: any) => {
                        setFieldValue(
                          "customerIds",
                          items.map((d: any) => d.id)
                        );
                        setState({
                          ...state,
                          selectedCustomers: items,
                          // pmsFile: {
                          //   ...state.pmsFile,
                          //   customerIds: items.map((d: any) => d.id),
                          // },
                        });
                      }}
                      disabled={!values.datacenterId}
                    />
                    {errors.customerIds && touched.customerIds && (
                      <Text className="error-msg">{errors.customerIds}</Text>
                    )}
                  </Stack.Item>
                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={childrenGap}
                      horizontalAlign="end"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeAddDialog()}
                        className="borderless-btn"
                      />
                      <PrimaryButton
                        type="submit"
                        text={data?._id ? "Update" : "Add"}
                      />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManagePMScheduleDialog;
